import type { IMSelectorsUnion } from "@whatslly/types/integrations/im/IMSelectorsTypes";
export const InjectSendMessage = Symbol("InjectSendMessage");
export interface ISendMessage {
  init?(selectors: IMSelectorsUnion): void;
  sendMessage(message: string, files?: File[], templateId?: string): Promise<void>;
}
